(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_common/banner-helpers/assets/javascripts/jackpots.js') >= 0) return;  svs.modules.push('/components/banner_common/banner-helpers/assets/javascripts/jackpots.js');

'use strict';

var format;
var productMapping;
if (svs.isServer) {
  var trinidad = require('trinidad-core').core;
  format = trinidad.components.require('utils', 'format').api;
  productMapping = trinidad.components.require('numbergames', 'product-mapping').productMapping;
} else {
  format = svs.utils.format;
  productMapping = svs.numbergames.productMapping;
}


function jackpots(_ref) {
  var product = _ref.product,
    jackpots = _ref.jackpots,
    getJackpot = _ref.getJackpot,
    weekDraws = _ref.weekDraws;
  if (product === 'rubbet') {
    var totalJackpotAmount = productMapping.getAllNumericIds().map(function (numericId) {
      return getJackpot({
        product: numericId,
        jackpots: jackpots,
        draws: weekDraws
      });
    }).reduce(function (sum, _ref2) {
      var jackpotAmount = _ref2.jackpotAmount;
      return sum + jackpotAmount;
    }, 0);
    return {
      jackpotLabel: 'Totala toppvinster',
      jackpotAmountString: "ca ".concat(format.CurrencyInMillions(totalJackpotAmount), " milj kr")
    };
  }
  var _getJackpot = getJackpot({
      product: product,
      jackpots: jackpots,
      draws: weekDraws
    }),
    defaultJackpot = _getJackpot.defaultJackpot,
    jackpotAmountStringShort = _getJackpot.jackpotAmountStringShort,
    description = _getJackpot.description;
  return {
    jackpotLabel: defaultJackpot ? "".concat(description, " alltid minst") : "".concat(description, " just nu"),
    jackpotAmountString: jackpotAmountStringShort.replace('minst ', '')
  };
}
if (svs.isServer) {
  module.exports = {
    jackpots: jackpots
  };
} else {
  svs.banner_common.banner_helpers.jackpots = jackpots;
}

 })(window);